import * as React from 'react'
// libs
import styled from 'styled-components'
import { Helmet } from 'react-helmet-async'
import { useRouter } from 'hooks/useRouter'
// components
import EditName from './components/EditName'
import TextFieldModal from 'components/Modals/TextFieldModal'
import AddFieldButton from './components/RiskTemplateFields/components/AddFieldButton'
import RiskTemplateCTA from 'components/PageComponents/RiskTemplates/Edit/components/CTA'
import LookupFilterModal from 'components/Modals/LookupFilterModal'
import RiskTemplateFields from './components/RiskTemplateFields'
import ConfirmDeleteModal from 'components/Modals/ConfirmDeleteModal'
import MainLayoutContainer from 'containers/MainLayout'
import AuthorizationWarning from 'components/UI/Warnings/AuthorizationWarning'
import TemplateSettingsDrawer from 'components/Modals/RiskTemplateSettingsModal'
import RiskTemplateSystemProcesses from 'components/PageComponents/RiskTemplates/Edit/components/SystemProcesses'
// themes
import { LayoutContainerInnerWrapper } from 'themes/views/layouts'
// constants
import { Modals } from 'constants/modals'
// context
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// hooks
import { useCurrentUser, useFormInitialValues } from 'hooks/index'
// utils
import get from 'lodash/get'

const Wrapper = styled.div`
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  padding-top: 8px;
  padding-right: 8px;
  margin-right: -20px;
  scroll-timeline: --rt-scroll block;
`

const RiskTemplate: React.FC = () => {
  const router = useRouter()

  const { riskTemplate, isLoading } = React.useContext(RiskTemplateAPIContext)

  const { initialValues, isInitialValuesLoaded } = useFormInitialValues(
    isLoading,
    get(riskTemplate, 'fieldValueMap', [])
  )

  const {
    permissionsFromSecurityGroups: { manageRiskTemplates }
  } = useCurrentUser()

  return (
    <>
      <Helmet>
        <title>Skefto - Edit Form Template</title>
      </Helmet>
      <MainLayoutContainer
        disableScroll
        label={<EditName />}
        CTA={<RiskTemplateCTA />}
        isLoading={isLoading || !isInitialValuesLoaded}>
        {manageRiskTemplates ? (
          <LayoutContainerInnerWrapper offset={20}>
            <Wrapper data-rt-scroll>
              <RiskTemplateFields initialValues={initialValues} />
              {!router.query.archived && <AddFieldButton />}
            </Wrapper>
          </LayoutContainerInnerWrapper>
        ) : (
          <AuthorizationWarning entityType='form template' />
        )}
      </MainLayoutContainer>

      {riskTemplate?.id && <RiskTemplateSystemProcesses riskTemplateId={riskTemplate.id} />}

      <TextFieldModal />
      <LookupFilterModal />
      <TemplateSettingsDrawer />
      <ConfirmDeleteModal header={`Delete ${riskTemplate?.name}`} modalType={Modals.CONFIRM_DELETE_RISK_TEMPLATE_MODAL}>
        Are you sure you want to delete this template?
      </ConfirmDeleteModal>
    </>
  )
}

export default RiskTemplate
